import { ColorsType } from './types';

export const colorsType: ColorsType[] = ['error', 'primary', 'secondary', 'success', 'warning'];

export const colors = {
  primary: {
    light: '#CDDBED',
    main: '#064DA3',
    dark: '#053E82',
  },
  warning: {
    light: '#FDE8D1',
    main: '#F68C19',
    dark: '#C57014',
  },
  success: {
    light: '#CCEFDB',
    main: '#00AD4D',
    dark: '#008A3E',
  },
  error: {
    light: '#f3d7d9',
    main: '#c13641',
    dark: '#9a2b34',
  },
  secondary: {
    light: '#fafafa',
    main: '#5f6368',
    dark: '#323232',
  },
  grey: {
    50: '#fafafa',
    100: '#D2D1D1',
    200: '#BCBABA',
    300: '#A5A3A3',
    400: '#8F8C8D',
    500: '#787576',
    600: '#625E5F',
    700: '#4B4748',
    800: '#353031',
    900: '#1E191A',
  },
  common: {
    white: '#ffffff',
    black: '#1E191A',
  },
};
